// Build metadata inlined at build time (see config-overrides.js, which derives
// the REACT_APP_BUILD_* variables from Travis). Local builds have a build time
// but no commit; unreplaced "%VAR%" placeholders are treated as unset.
const read = (value) =>
  value && !String(value).startsWith('%') ? String(value) : undefined;

const sha = read(process.env.REACT_APP_BUILD_SHA);

export const buildInfo = {
  sha,
  shortSha: sha ? sha.slice(0, 7) : undefined,
  branch: read(process.env.REACT_APP_BUILD_BRANCH),
  number: read(process.env.REACT_APP_BUILD_NUMBER),
  time: read(process.env.REACT_APP_BUILD_TIME),
};

// One-line description, e.g. "build #4677 | master | 9db0d874... | 2026-10-23T13:00:00Z"
export const describeBuild = () =>
  [
    buildInfo.number && `build #${buildInfo.number}`,
    buildInfo.branch,
    buildInfo.sha,
    buildInfo.time,
  ]
    .filter(Boolean)
    .join(' | ');
